import template from './interactive-report-view.html';
import { get } from 'lodash-es';
import exportOptionsPopupTemplate from '../export-options-popup/export-options-popup.html';
import overwritePopupTemplate from '../overwrite-cutom-view-popup/overwrite-custom-view-popup.html';
import deletePopupTemplate from '../delete-custom-view-popup/delete-custom-view-popup.html';

const REGEX_MATCH_EXPORT = /.*- Export/;

const CUSTOM_VIEWS_OPERATIONS = {
  REMOVE: 'REMOVE',
  APPLY: 'APPLY',
  SAVE: 'SAVE',
};
const MAX_CUSTOM_VIEWS = 60;
class InteractiveReportController {
  constructor(
    reportingService,
    securityGroupsService,
    usersService,
    $stateParams,
    $sce,
    $scope,
    $q,
    $timeout,
    appSettings,
    $rootScope,
    $uibModal,
    gettextCatalog,
  ) {
    'ngInject';
    this.reportingService = reportingService;
    this.securityGroupsService = securityGroupsService;
    this.usersService = usersService;
    this.$stateParams = $stateParams;
    this.$sce = $sce;
    this.iframeSrc = '';
    this.$scope = $scope;
    this.$q = $q;
    this.$timeout = $timeout;
    this.appSettings = appSettings;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.language = 'en';
    this.gettextCatalog = gettextCatalog;

    // Tableau specifics
    this.tableauFilters = [];
    this.viz;
    this.activeSheet = null;
    this.workbook = null;
    // Exporting and Custom Views
    this.exportOptions = [];
    this.customViews = [{ name: '', isDefault: true }];
    this.customViewDropdownOpen = false;
    this.selectedCustomView = this.customViews[0];
    this.newCustomViewName = '';
    this.inputCustomViewOpen = false;
    this.isEditingCustomView = false;
    this.editViewName = '';
    this.maxCustomViews = MAX_CUSTOM_VIEWS;
    this.isDefaultSelected = false;
    this.isTypingCustomViewName = false;
    this.showCustomViewNameError = false;

    this.updateFilter = null;
    this.leftNavNode = null;
    this.showExport = false;

    this.refreshUrl = this.$sce.trustAsResourceUrl(`${appSettings.RepotingApiUrl}/refresh`);

    this.callbackFunction = (callbackFunc) => {
      callbackFunc();
    };
  }
  $onInit() {
    this.status = 'loading';
    this.reportId = this.$stateParams.reportId;
    this.updateBreadcrumb(this.$stateParams.reportName);
    this.language = this.appLanguage;
    //this.getLeftNavNode();
    //this.changeDisplayLeftNav(false);
  }

  //un alternet way to $postLink() could be using timeout in $onInit
  //will get the report after the ifram has made the call to reset the cookie
  $postLink() {
    const requests = [this.getInteractiveReport(this.reportId), this.getSecurityGroupsNames()];
    this.$q
      .all(requests)
      .then(result => {

        const [reportResult, securityGroupsNames] = result;

        this.status = '';
        let path = reportResult.viewPath ? `${reportResult.viewPath}` : '';
        this.iframeSrc = this.$sce.trustAsResourceUrl(path);
        this.updateBreadcrumb(reportResult.name);
        this.initViz(path, securityGroupsNames);
        this.tableauFilters = reportResult.filters || [];
      })
      .catch(error => {
        this.status = 'error';
        this.iframeSrc = '';
      })
  }
  $onChanges() {}

  $onDestroy() {
    this.changeDisplayLeftNav(true);
  }

  getExportOptions() {
    if (this.activeSheet) {
      this.exportOptions = this.activeSheet
        .getWorksheets()
        .filter((worksheet) => REGEX_MATCH_EXPORT.test(worksheet.getName()))
        .map((worksheet) => worksheet.getName());
    }
  }

  getSecurityGroupsNames() {
    return this.securityGroupsService.getAllSecurityGroups().then(response => {
      const { data: {
        data: securityGroups
      } } = response;

      return securityGroups.map(securityGroup => securityGroup.name);
    });
  }

  getCustomViews() {
    if (this.viz && this.workbook) {
      this.workbook.getCustomViewsAsync().then((result) => {
        this.$scope.$apply(() => {
          const parsedCustomViews = result?.map((customView) => ({
            name: customView?.getName(),
            isDefault: customView.getDefault(),
          }));
          this.customViews = [...this.customViews, ...parsedCustomViews];
          // Select Default custom view
          const foundDefault = parsedCustomViews.find((customView) => customView.isDefault);
          if (foundDefault) {
            this.selectedCustomView = foundDefault;
            this.customViews[0].isDefault = false;
          }
        });
      });
    }
  }

  customViewOperationTableau(operation, customViewName, callbackFunction) {
    let tableauFunction = null;
    let loggingOperation = '';

    switch (operation) {
      case CUSTOM_VIEWS_OPERATIONS.APPLY:
        tableauFunction = this.workbook.showCustomViewAsync(customViewName);
        loggingOperation = 'applied';
        break;
      case CUSTOM_VIEWS_OPERATIONS.REMOVE:
        tableauFunction = this.workbook.removeCustomViewAsync(customViewName);
        loggingOperation = 'removed';
        break;
      case CUSTOM_VIEWS_OPERATIONS.SAVE:
        tableauFunction = this.workbook.rememberCustomViewAsync(customViewName);
        loggingOperation = 'saved';
        break;
    }

    tableauFunction.then((result) => {
      if (tableauFunction) callbackFunction(result);
      console.log(`Custom view : '${result?.getName()}' ${loggingOperation} successfully`);
    });
  }

  applyCustomView(customView, callbackFunction = null) {
    this.selectedCustomView = customView;

    this.customViewOperationTableau(
      CUSTOM_VIEWS_OPERATIONS.APPLY,
      this.selectedCustomView?.name,
      callbackFunction,
    );
  }

  saveCustomView(customViewName, isNew) {
    this.customViewOperationTableau(CUSTOM_VIEWS_OPERATIONS.SAVE, customViewName, (result) => {
      if (isNew) {
        this.$scope.$apply(() => {
          const resultCustomView = { name: result?.getName(), isDefault: result?.getDefault() };
          this.customViews.push(resultCustomView);
          this.selectedCustomView = resultCustomView;
        });
      }
    });
  }

  editCurrentCustomView() {
    this.isTypingCustomViewName = false;
    // Check if already in use name
    const alreadyInUse = this.customViewNameAlreadyInUse();
    if (alreadyInUse || this.gettextCatalog.getString("Initial View") === this.editViewName) {
      this.showCustomViewNameError = true;
      return;
    }

    const isCurrentlyDefault = this.selectedCustomView.isDefault;
    // Delete the current custom view
    this.deleteCustomView();
    // Save current state with different name;
    this.customViewOperationTableau(CUSTOM_VIEWS_OPERATIONS.SAVE, this.editViewName, (result) => {
      this.$scope.$apply(() => {
        this.customViews.push({ name: result?.getName(), isDefault: result?.getDefault() });
        this.selectedCustomView.name = result?.getName();
        if (isCurrentlyDefault) this.setCurrentViewAsDefault();
      });
    });
    this.toggleEditing();
  }

  deleteCustomView() {
    this.customViewOperationTableau(
      CUSTOM_VIEWS_OPERATIONS.REMOVE,
      this.selectedCustomView.name,
      null,
    );

    this.customViews = this.customViews.filter(
      (customView) => customView.name !== this.selectedCustomView.name,
    );
  }

  setCurrentViewAsDefault() {
    this.selectedCustomView = { ...this.selectedCustomView, isDefault: true };
    this.customViews = this.customViews.map((customView) => ({
      ...customView,
      isDefault: this.selectedCustomView.name === customView.name,
    }));
    this.workbook?.setActiveCustomViewAsDefaultAsync().then(() => {});
  }

  customViewButtonClicked() {
    if (this.inputCustomViewOpen && this.newCustomViewName) {
      this.isTypingCustomViewName = false;
      //Check if custom view name is already in use
      const alreadyInUse = this.customViewNameAlreadyInUse();

      if (alreadyInUse || this.gettextCatalog.getString("Initial View") === this.newCustomViewName) {
        this.showCustomViewNameError = true;
        return;
      }
      this.saveCustomView(this.newCustomViewName, true);
      this.newCustomViewName = '';
    }
    this.inputCustomViewOpen = !this.inputCustomViewOpen;
  }

  toggleEditing() {
    this.isEditingCustomView = !this.isEditingCustomView;
    this.editViewName = this.isEditingCustomView ? this.selectedCustomView.name : '';
  }
  toggleErrorMessage() {
    this.$timeout(() => this.showCustomViewNameError = false, 2);
    return true;
  }

  popupCustomView(template, controllerName, controllerAsName) {
    return this.$uibModal.open({
      animation: true,
      template: template,
      controller: controllerName,
      controllerAs: controllerAsName,
      resolve: {
        view: () => this.selectedCustomView,
      },
      size: 'sm',
    }).result;
  }

  overwriteCustomView() {
    this.popupCustomView(
      overwritePopupTemplate,
      'OverwriteCustomViewPopupController',
      'overwritePopupVm',
    )
      .then((result) => {
        this.saveCustomView(this.selectedCustomView.name, false);
      })
      .catch((error) => {
        console.log(`Overwrite modal closed by: ${error}`);
      });
  }
  promptRemoveCustomView() {
    this.popupCustomView(deletePopupTemplate, 'DeleteCustomViewPopupController', 'deletePopupVm')
      .then((result) => {
        const isCurrentViewDefault = this.selectedCustomView.isDefault;
        this.deleteCustomView();

        if (isCurrentViewDefault) {
          this.selectedCustomView = { name: '', isDefault: isCurrentViewDefault };
          this.customViews[0].isDefault = isCurrentViewDefault;
        }
        this.applyCustomView(this.customViews[0]);
        this.toggleEditing();
      })
      .catch((error) => {
        console.log(`Remove popup closed by: ${error}`);
      });
  }

  closeCustomViewCreation() {
    this.newCustomViewName = '';
    this.inputCustomViewOpen = false;
  }

  getInteractiveReport(id) {
    return this.reportingService.getReportById(id);
  }

  initViz(viewPath, securityGroupsNames) {
    angular.element(() => {
      const containerDiv = document.getElementById('vizContainer');
      const url = viewPath;
      const options = {
        hideTabs: false,
        hideToolbar: true,
        onFirstInteractive: () => {
          this.workbook = this.viz.getWorkbook();
          this.activeSheet = this.workbook.getActiveSheet();
          //this.getAllFilters();
          this.$scope.$apply(() => (this.showExport = true));
          this.getCustomViews();
          this.getExportOptions();
        },
        onFirstVizSizeKnown: () => {
          console.log('onFirstVizSizeKnown');
        },
        language: this.language,
      };

      const { securityMode = ""} = this.usersService.currentUser();


      if (securityGroupsNames.length > 0 && securityMode !== "Open") {
        options["security_group_name"] = [...securityGroupsNames];
      }

      this.viz = new tableau.Viz(containerDiv, url, options);
    });
  }

  updateBreadcrumb(reportName) {
    this.reportName = reportName;
    //fire this for breadcrumb to update itself after setting report name
    this.$scope.$emit('$viewContentLoaded');
  }
  getLeftNavNode() {
    const domNodes = document.getElementsByClassName('fixed-left-nav');

    if (domNodes.length > 0) {
      this.leftNavNode = domNodes[0];
    }
  }

  changeDisplayLeftNav(showNav = true) {
    if (this.leftNavNode) {
      this.leftNavNode.style.display = showNav ? 'block' : 'none';
    }
  }

  getAllFilters() {
    const worksheets = this.activeSheet.getWorksheets();

    if (Array.isArray(worksheets) && worksheets.length > 1) {
      const worksheetObject = worksheets[1];

      const tableauPromises = [
        this.workbook.getParametersAsync(),
        worksheetObject.getFiltersAsync(),
      ];

      Promise.allSettled(tableauPromises).then((values) => {
        const [paramResponse, filterResponse] = values;

        this.populateFilterValues(paramResponse.value, filterResponse.value);
        this.updateFilter(this.tableauFilters);
      });
    }
  }

  flattenTableauFilters(filters = [], isParameter = false) {
    const filterObject = {};
    for (const filter of filters) {
      const filterName = isParameter ? filter.getName() : filter.getFieldName();
      const filterValues = isParameter ? filter.getAllowableValues() : filter.getAppliedValues();

      if (filterName && Array.isArray(filterValues) && filterValues.length > 0) {
        filterObject[filterName] = filterValues;
      }
    }
    return filterObject;
  }
  customViewNameAlreadyInUse() {
    return (
      this.customViews.filter((customView) => {
        const customViewToCheck = !this.isEditingCustomView
          ? this.newCustomViewName
          : this.editViewName;
        return customViewToCheck === customView.name;
      }).length > 0
    );
  }

  populateFilterValues(parameters = [], filters = []) {
    const parametersMap = this.flattenTableauFilters(parameters, true);
    const filtersMap = this.flattenTableauFilters(filters, false);

    this.tableauFilters = this.tableauFilters.map((filter) => {
      const { isParameter, name: filterName } = filter;
      let matchedArray = isParameter ? parametersMap[filterName] : filtersMap[filterName];

      if (matchedArray) {
        // Filter null
        matchedArray = matchedArray.filter((match) => match.value !== null);

        filter.values = isParameter
          ? matchedArray.map((match) => ({ label: match.formattedValue, value: match.value }))
          : matchedArray.map((match) => ({ selected: true, text: match.value }));
      }
      return filter;
    });
  }

  get appLanguage() {
    return get(this.$rootScope, 'currentUser.claims.data.language', 'en');
  }

  applyFilter(filter) {
    const { name, values } = filter || {};

    if (name && values && this.activeSheet) {
      let type = filter.type;

      if (!type) {
        type = tableau.FilterUpdateType.REPLACE;
      }

      this.activeSheet.getWorksheets()[1].applyFilterAsync(name, values, type);
    }
  }

  changeParameter(parameter) {
    const { name, value = null } = parameter || {};

    if (name && value !== null && this.workbook) {
      this.workbook.changeParameterValueAsync(name, value);
    }
  }

  exportToPDF() {
    if (this.viz) {
      this.viz.showExportPDFDialog();
    }
  }

  exportToCSV() {
    const modalInstance = this.$uibModal.open({
      animation: true,
      template: exportOptionsPopupTemplate,
      controller: 'ExportOptionsPopupController',
      controllerAs: 'exportOptionsPopupVm',
      resolve: {
        exportOptions: () =>
          this.exportOptions?.map((exportOption) => ({
            label: this.gettextCatalog.getString(exportOption.replace('- Export', '')?.trim()),
            value: exportOption,
          })),
      },
      size: 'sm',
    });

    modalInstance.result
      .then((selectedOption) => {
        const { value = '' } = selectedOption;
        if (this.viz && this.activeSheet && value) {
          if (value === '__all__') {
            this.exportOptions.forEach((option) => {
              this.viz.showExportCrossTabDialog(option);
            });
          } else {
            this.viz.showExportCrossTabDialog(value);
          }
        }
      })
      .catch((error) => console.log('Modal error: ' + error));
  }

  exportToImage() {
    if (this.viz && this.activeSheet) {
      this.viz.showExportImageDialog();
    }
  }
}

export default {
  template,
  controller: InteractiveReportController,
  bindings: {},
};
